/*
 * Author: harper
 * File Created: Friday, 24-07-05 04:14 pm
 * Last Modified: Friday, 25-06-27 02:51 pm, by Dw
 */
import { useEffect, useRef } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { isOpenApi } from '@ucard/next-core/utils';
import { Container, Grid } from '@mui/material';
import { Flex } from '@ucard/ds/containers';
import type { ContentBoxProps } from './ContentBox';
import ContentBox from './ContentBox';
import Header from './Header';
import PageRefresh from './PageRefresh';
export default function AppContainer(props: ContentBoxProps & {
  hideHeader?: boolean;
  hideMenu?: boolean;
  meta?: {
    title: string;
    description?: string;
  };
}) {
  const {
    locale
  } = useRouter();
  const ctnRef = useRef<HTMLElement>();
  useEffect(() => {
    // this is sepecific for fixing height issue on safari
    const updateHeight = () => {
      if (ctnRef.current) {
        const vh = window.innerHeight;
        ctnRef.current.style.height = `${vh}px`;
      }
    };

    // 设置初始高度
    updateHeight();

    // 添加事件监听器
    window.addEventListener('resize', updateHeight);
    window.addEventListener('orientationchange', updateHeight);

    // 清理事件监听器
    return () => {
      window.removeEventListener('resize', updateHeight);
      window.removeEventListener('orientationchange', updateHeight);
    };
  }, []);
  const {
    hideHeader = false,
    hideMenu = false,
    hideBreadcrumb,
    meta,
    ...rest
  } = props;
  return <Flex className="page-main" flexDirection="column" height="100vh" id="main" lang={locale} ref={ctnRef} data-sentry-element="Flex" data-sentry-component="AppContainer" data-sentry-source-file="index.tsx">
      {meta && <Head>
          <title>{meta.title}</title>
          {meta.description && <meta content={meta.description} name="description" />}
        </Head>}
      <PageRefresh data-sentry-element="PageRefresh" data-sentry-source-file="index.tsx" />
      {!hideHeader && <Header hideMenu={isOpenApi || hideMenu} />}
      <Flex bgcolor="#000000" flex={1} flexDirection="column" overflow="hidden" py={{
      xs: 0,
      sm: 5
    }} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Container disableGutters maxWidth="md" sx={{
        display: 'flex',
        height: '100%',
        justifyContent: 'center'
      }} data-sentry-element="Container" data-sentry-source-file="index.tsx">
          <Grid container justifyContent="center" data-sentry-element="Grid" data-sentry-source-file="index.tsx">
            <Grid height="100%" item md={6} sm={7} xs={12} data-sentry-element="Grid" data-sentry-source-file="index.tsx">
              <ContentBox hideBreadcrumb={hideBreadcrumb || isOpenApi} {...rest} data-sentry-element="ContentBox" data-sentry-source-file="index.tsx" />
            </Grid>
          </Grid>
        </Container>
      </Flex>
    </Flex>;
}